import { render, staticRenderFns } from "./create.vue?vue&type=template&id=0b945758"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b945758')) {
      api.createRecord('0b945758', component.options)
    } else {
      api.reload('0b945758', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=0b945758", function () {
      api.rerender('0b945758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/training/create.vue"
export default component.exports